import { DocumentPredefinedType, IDocument, IDocumentSummary } from 'gen/ApiClient';
import { IDocumentX } from '../dialogs/scanOrUpload/IDocumentX';

export const translateDocumentType = (document: IDocumentSummary | IDocument | IDocumentX, record: Record<DocumentPredefinedType, string>): string => {
	return document.predefinedType ? record[document.predefinedType as DocumentPredefinedType] : document.typeOrName ?? '';
};
